import PatchOps from '@leverege/api-patch-ops'

import { updateBlueprint } from './BlueprintActions'

/*
  Usage:
    let updater = BlueprintUpdater( dispatch, blueprint )
      .set( "a/string/to/a/path", "value 1" )
      .set( "a/string/to/another/path", "value 2" )
      .done()
 */

function BlueprintUpdater( dispatch, blueprint, key, value ) {
  const patchOps = PatchOps( key, value )
  patchOps.done = () => dispatch( updateBlueprint( blueprint, patchOps.ops() ) )
  return patchOps
}

module.exports = BlueprintUpdater
